// Mémoire de la session uniquement : aucun fichier ni contenu dans localStorage.
// Une publication explicitement demandée doit survivre au changement de mur.
const publications = new Map();
const listeners = new Map();

export const publicationKey = (userId, prospectId, module) => JSON.stringify([userId, prospectId, module]);
export const getPublication = key => publications.get(key);
export const forgetPublication = key => publications.delete(key);

export const subscribePublication = (key, listener) => {
    if (!listeners.has(key)) listeners.set(key, new Set());
    listeners.get(key).add(listener);
    return () => {
        const group = listeners.get(key);
        group?.delete(listener);
        if (!group?.size) listeners.delete(key);
    };
};

export const updatePublication = (key, entry, note = null) => {
    if (entry) publications.set(key, entry);
    else publications.delete(key);
    listeners.get(key)?.forEach(listener => listener({ entry, note }));
};